$(function () {

  // prevent event key from triggering submit
  var allowSubmit = false;
  
  $('form').on('submit', function () {
    return allowSubmit;
  });

  $('.modal-footer .btn-primary').on('click', function () {
    allowSubmit = true;
    $('form').trigger('submit');
  });

  // page slug auto-generation
  $('#page_title').on('input', function () {
    var val = $(this).val();

    $('#page_slug').val(val.toLowerCase().replace(/[^0-9a-z-_]/g, '-'));
  });

});